import {inject, Injectable} from '@angular/core';
import {getUserInstance, User} from 'app/core/types/smm/smm-person.types';
import {
    BehaviorSubject,
    Observable
} from 'rxjs';
import {ImgService} from "./img.service";
import {RecentPatientsService} from "../../features/patient/recent-accesed-patients/recent.accesed.patientsservice.";

@Injectable({ providedIn: 'root' })
export class SMMUserSelectionService {
    //services
    private _imgService: ImgService = inject(ImgService);
    private _recentPatientsService: RecentPatientsService = inject(RecentPatientsService);

    //observables
    private _selectedUser: BehaviorSubject<User | null> = new BehaviorSubject(getUserInstance());
    private _selectedMedic: BehaviorSubject<User | null> = new BehaviorSubject(getUserInstance());
    private _busy: BehaviorSubject<boolean> = new BehaviorSubject(false);

    get busy$(){
        return this._busy.asObservable();
    }

    private async updateUserImg(usr: User): Promise<User> {
        //update
        if (usr?.userProfilePath) {
            const img:Blob = await this._imgService.getAvatar(usr);
            if(img != null){
                this._imgService.setAvatarImgFromBlob(usr, img);
            }
        }
        return usr;
    }

    get selectedUser$(): Observable<User>{
        return this._selectedUser.asObservable();
    }

    updateSelectedUser(selectedUser: User) {
        if(SMMUserSelectionService.usersAreTheSame(selectedUser, this._selectedUser.value)){
            //don't update if same
            return;
        }
        this.updateUserImg(selectedUser).then(r => {
            this._recentPatientsService.add(selectedUser);
            this._selectedUser.next(selectedUser);
            localStorage.setItem('selectedPatient',selectedUser.id);
        });
    }

    async updateSelectedUserWithWait(selectedUser: User) {
        if(SMMUserSelectionService.usersAreTheSame(selectedUser, this._selectedUser.value)){
            //don't update if same
            return;
        }
        const updatedUser = await this.updateUserImg(selectedUser);
        this._recentPatientsService.add(updatedUser);
        this._selectedUser.next(updatedUser);
        localStorage.setItem('selectedPatient',selectedUser.id);
    }

    get currentlySelectedUser(): User{
        return this._selectedUser.value;
    }

    get selectedMedic$(): Observable<User>{
        return this._selectedMedic.asObservable();
    }

    get currentlySelectedMedic(): User{
        return this._selectedMedic.value;
    }

    updateSelectedMedic(selectedUser: User) {
        if(!(selectedUser?.medicInfo?.id)){
            //don't update if no medic info
            return;
        }

        if(SMMUserSelectionService.usersAreTheSame(selectedUser, this._selectedMedic.value)){
            //don't update if same
            return;
        }

        //update imediatly to make sure we don't trigger  this._selectedMedic.next multiple times, which notifies all subscribers
        this._selectedMedic.next(selectedUser);
        this.updateUserImg(selectedUser).then(r => {
            //update with picture
            this._selectedMedic.next(r);
            localStorage.setItem('selectedMedic', selectedUser.id);
        });
    }

    public static usersAreTheSame(newUser: User, oldUser:User):boolean{
        return newUser?.id === oldUser?.id &&
               newUser?.userRole?.length == oldUser?.userRole?.length &&
               newUser?.firstName == oldUser?.firstName &&
               newUser?.lastName == oldUser?.lastName &&
               newUser?.phoneNumber == oldUser?.phoneNumber &&
               newUser?.email == oldUser?.email &&
               newUser?.patientInfo?.id == oldUser?.patientInfo?.id &&
               newUser?.medicInfo?.id == oldUser?.medicInfo?.id;
    }
}
